const key = { enter: 13, space: 32 };

class DigitalPayListItemController {
    onKeyDown($event) {
        if ($event.keyCode === key.enter || $event.keyCode === key.space) {
            this.onClick();
        }
    }
}

const digitalPayListItemComponentDefinition = {
    controller: DigitalPayListItemController,
    template: require('./digital-pay-list-item.component.html').trim(),
    transclude: true,
    bindings: {
        icon: '@',
        isSelected: '<?',
        isDisabled: '<?', // Overrides selected
        isCondensed: '<?',
        isClickEnabled: '<?',
        isError: '<?', // Overrides selected and disabled
        onClick: '&?',
        tickStampClass: '@', // Class Modifier for the tick stamp
    },
};

module.exports = {
    digitalPayListItemComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/wallet/common/digital-pay-list-item.component.js